import { CompanySettingsContent } from "../../features/companyWorkspace";

function CompanySettingsScreen() {
  return <CompanySettingsContent />;
}

export default CompanySettingsScreen;
